import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getPurchaseRefunds } from "api/purchaseRefund.api";
import { gracefulList } from "lib/queryHelpers";
import { QUERY_KEYS } from "config/queryKeys";
import { DEFAULT_STALE_TIME } from "config/constants";

const mapRefund = (r) => ({
  id: r.id || r._id,
  vendorName: r.vendorName || "—",
  billNumber: "—",
  refundNumber: r.documentNumber,
  refundDate: r.refundDate,
  refundMode: r.paymentMode,
  receivedTo: r.refundTo || "—",
  reference: r.reference || "",
  netAmount: r.amount ?? 0,
  totalVat: 0,
  status: r.status,
  notes: r.reason || "",
  lines: [],
  raw: r,
});

export const useGetPurchaseRefunds = (params = {}) => {
  const queryClient = useQueryClient();
  return useQuery({
    queryKey: QUERY_KEYS.purchaseRefunds.list(),
    queryFn: gracefulList(() => getPurchaseRefunds(params), { refunds: [] }),
    initialData: () =>
      queryClient.getQueryData(QUERY_KEYS.purchaseRefunds.list()),
    select: (data) => (data?.refunds || []).map(mapRefund),
    staleTime: DEFAULT_STALE_TIME,
  });
};
